import React from 'react';
import { Info } from 'lucide-react';
import { StatusBadge, fmt } from './ReleasesList';

export const ReleaseStatusBar = ({ release }) => (
  <div data-testid="publish-status-bar" className="rounded-xl border border-blue-200 bg-blue-50 p-4 flex flex-wrap items-center gap-3 text-sm text-slate-800">
    <Info className="w-5 h-5 text-blue-600 shrink-0" />
    {release ? (
      <>
        <span className="font-bold">آخر إصدار:</span><StatusBadge status={release.status} />
        <span>{fmt(release.applied_at || release.created_at)}</span>
        {release.status === 'approved' && <span className="text-blue-700 font-bold">اضغط Deploy في Emergent ليُطبَّق على الموقع الحي.</span>}
      </>
    ) : <span>لم يُعتمد أي إصدار بعد. التعديلات هنا لا تظهر للزوار حتى تعتمد إصداراً وتضغط Deploy.</span>}
  </div>
);
